import { useState } from "react";
import "./Calculator.css"; // ← Ici on importe le CSS

const Calculator = () => {
  const [input, setInput] = useState("");

  const handleButtonClick = (value) => {
    setInput((prevInput) => prevInput + value);
  };

  const handleClear = () => {
    setInput("");
  };

  const handleCalculate = () => {
    try {
      setInput(eval(input).toString());
    } catch (error) {
      setInput("Erreur");
    }
  };

  return (
    <div className="calculator-container">
      <h2 className="calculator-title">Calculatrice</h2>
      <input 
        type="text" 
        value={input} 
        readOnly 
        className="calculator-input"
      />
      <div className="calculator-buttons">
        {["7", "8", "9", "/", "4", "5", "6", "*", "1", "2", "3", "-", "0", ".", "+", "="].map((btn, index) => (
          <button 
            key={index}
            onClick={() => {
              if (btn === "=") {
                handleCalculate();
              } else {
                handleButtonClick(btn);
              }
            }}
            className={`calculator-button ${btn === "=" ? "calculate" : ""}`}
          >
            {btn}
          </button>
        ))}
        <button onClick={handleClear} className="calculator-button clear">
          C
        </button>
      </div>
    </div>
  );
};

export default Calculator;
